import { useLayoutEffect } from 'react';

const useBodyScrollLock = (isActive: boolean) => {

	useLayoutEffect(() => {
		if (isActive) {
			document.body.classList.add('overflow-hidden');
			document.body.classList.add('fixed');
		} else {
			document.body.classList.remove('overflow-hidden');
			document.body.classList.remove('fixed');
		}
	}, [isActive]);
};

export default useBodyScrollLock;
